import type { EducationLevel } from './stats.js';

export type JobId = 'caixa' | 'escritorio' | 'gestor' | 'director' | 'ceo';

export type Job = {
  readonly id: JobId;
  readonly minEducation: EducationLevel;
  readonly hourlyWage: number;
  readonly scoreValue: number;
  readonly requiresSuit?: boolean;
};

export const JOBS: Readonly<Record<JobId, Job>> = Object.freeze({
  caixa: { id: 'caixa', minEducation: 0, hourlyWage: 800, scoreValue: 25 },
  escritorio: { id: 'escritorio', minEducation: 2, hourlyWage: 1500, scoreValue: 50 },
  gestor: { id: 'gestor', minEducation: 3, hourlyWage: 3000, scoreValue: 75 },
  director: { id: 'director', minEducation: 4, hourlyWage: 4500, scoreValue: 90 },
  ceo: { id: 'ceo', minEducation: 5, hourlyWage: 6000, scoreValue: 100, requiresSuit: true },
});

export const JOB_LADDER: readonly JobId[] = Object.freeze([
  'caixa',
  'escritorio',
  'gestor',
  'director',
  'ceo',
]);

export function jobLadderIndex(jobId: JobId | null): number {
  if (jobId === null) return -1;
  return JOB_LADDER.indexOf(jobId);
}

export function nextJob(jobId: JobId | null): JobId | null {
  const idx = jobLadderIndex(jobId);
  if (idx === -1) return JOB_LADDER[0]!;
  if (idx >= JOB_LADDER.length - 1) return null;
  return JOB_LADDER[idx + 1]!;
}

export function daysRequiredFor(jobId: JobId): number {
  return jobLadderIndex(jobId);
}

export function jobsAvailable(level: EducationLevel): readonly Job[] {
  return Object.values(JOBS).filter((j) => j.minEducation <= level);
}
